// extracted by mini-css-extract-plugin
module.exports = {"clickabledRateCardList":"ClickabledRateCardList_clickabledRateCardList__sKzQH","clickableRateCard":"ClickabledRateCardList_clickableRateCard__1FDrk"};